import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-427b8493"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "test-header"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "part" }, "PART", -1))
const _hoisted_3 = { class: "number" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "READING COMPREHENSION", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("見直"),
  /*#__PURE__*/_createElementVNode("rt", null, "みなお")
], -1))
const _hoisted_6 = {
  key: 1,
  class: "test-pager"
}
const _hoisted_7 = {
  key: 0,
  class: "test"
}
const _hoisted_8 = { class: "test-title" }
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("練習問題"),
  /*#__PURE__*/_createElementVNode("rp", null, "（"),
  /*#__PURE__*/_createElementVNode("rt", null, "れんしゅうもんだい"),
  /*#__PURE__*/_createElementVNode("rp", null, "）")
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "text" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "test-section" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode("前"),
    /*#__PURE__*/_createElementVNode("rp", null, "（"),
    /*#__PURE__*/_createElementVNode("rt", null, "まえ"),
    /*#__PURE__*/_createElementVNode("rp", null, "）")
  ]),
  /*#__PURE__*/_createTextVNode("へ")
], -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode("次"),
    /*#__PURE__*/_createElementVNode("rp", null, "（"),
    /*#__PURE__*/_createElementVNode("rt", null, "つぎ"),
    /*#__PURE__*/_createElementVNode("rp", null, "）")
  ]),
  /*#__PURE__*/_createTextVNode("へ")
], -1))
const _hoisted_21 = { class: "warning-modal" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("ruby", null, [
      /*#__PURE__*/_createTextVNode("試験"),
      /*#__PURE__*/_createElementVNode("rp", null, "（"),
      /*#__PURE__*/_createElementVNode("rt", null, "しけん"),
      /*#__PURE__*/_createElementVNode("rp", null, "）")
    ]),
    /*#__PURE__*/_createTextVNode("を"),
    /*#__PURE__*/_createElementVNode("ruby", null, [
      /*#__PURE__*/_createTextVNode("終"),
      /*#__PURE__*/_createElementVNode("rp", null, "（"),
      /*#__PURE__*/_createElementVNode("rt", null, "お"),
      /*#__PURE__*/_createElementVNode("rp", null, "）")
    ]),
    /*#__PURE__*/_createTextVNode("わりますか？")
  ])
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode("続"),
    /*#__PURE__*/_createElementVNode("rp", null, "（"),
    /*#__PURE__*/_createElementVNode("rt", null, "つづ"),
    /*#__PURE__*/_createElementVNode("rp", null, "）")
  ]),
  /*#__PURE__*/_createTextVNode("ける")
], -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode("終"),
    /*#__PURE__*/_createElementVNode("rp", null, "（"),
    /*#__PURE__*/_createElementVNode("rt", null, "お"),
    /*#__PURE__*/_createElementVNode("rp", null, "）")
  ]),
  /*#__PURE__*/_createTextVNode("わる")
], -1))
const _hoisted_26 = [
  _hoisted_25
]

import { inject, onMounted, ref } from "vue"
import { useRoute, useRouter } from 'vue-router'
import gsap from 'gsap'
import Answer from '@/components/parts/Answer.vue'
import Layout4 from '@/components/question/Layout4.vue'
import Layout5 from '@/components/question/Layout5.vue'
import Layout7 from '@/components/question/Layout7.vue'
import Layout9 from '@/components/question/Layout9.vue'
import Tutorial from '@/components/tutorials/Example.vue'
import Modal from '@/components/parts/Modal.vue'
import Timer from '@/components/parts/Timer.vue'
import { appKey, examKey } from "@/main";
import { Page, Part } from "@/store/exam";
import DemoControl from "@/components/parts/DemoControl.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReadingTest',
  emits: ['overridePageName'],
  setup(__props, { emit }) {

const app = inject(appKey);
const exam = inject(examKey);


const route = useRoute();
const router = useRouter();

const currentPage = ref<number>(1);
const lastPage = ref<number>(100);
const question = ref<Page | null>(null);
const part = ref<Part | null>(null);
const mounted = ref<boolean>(false);
const selected = ref<number>(0);
const currentPartQuestions = ref<Page[] | null>(null);
const group = route.params.group;
const startTutorial = ref<boolean>(false);
const tutorialTimeHandler = ref<number | null>(null);
const nextButton = ref();
const disableButton = ref<boolean>(false);
const visibleWarningModal = ref<boolean>(false);
const timeRemaining = ref<number | null>(null);
const timeInitial = ref<number>(0);
const isReachedLastQuestion = ref<boolean>(false);

// ページ更新
const updatePage = async (page: number) => {
  if (!exam) return;
  console.log(`ReadingTest updatePage ${page}`);

  startTutorial.value = false;

  currentPage.value = page;
  const questions = await exam.questions();
  const nextPart = questions.reading.parts.filter(x => x.partNumber == questions.reading.pages[page].partNumber)[0];
  question.value = questions.reading.pages[page];

  if (part.value == null || nextPart.partNumber != part.value.partNumber) {
    currentPartQuestions.value = questions.reading.pages.filter(x => x.partNumber == nextPart.partNumber && !x.example);
  }
  part.value = nextPart;

  lastPage.value = questions.reading.pages.length-1;

  const session = await exam.session();
  session.answer.readingProgress = page > session.answer.readingProgress ? page : session.answer.readingProgress;

  selected.value = question.value.example ? 0 : session.answer.reading[page];

  if (question.value.example) {
    emit('overridePageName', 'training-test');
    tutorialTimeHandler.value = setTimeout(() => {
      startTutorial.value = true;
    }, 4000)
  }
  else {
    emit('overridePageName', 'test');
  }

  setTimeout(() => {
    disableButton.value = false;
  }, 500);

  await exam.updateSession(session);
}

// ページ切り替え
const changePage = async(page: number) => {
  if (tutorialTimeHandler.value !== null) {
    clearTimeout(tutorialTimeHandler.value);
  }
  disableButton.value = true;
  if (!exam || !question.value) return;

  const questions = await exam.questions();
  if (page < questions.reading.pages.length) {
    const nextPagePart = questions.reading.pages[page].partNumber;
    const currentPagePart = question.value.partNumber;
    question.value = null;
    if (questions.reading.pages[page].example) {
      router.replace(`/cbt/${group}/reading/${page}/flow`);
    }
    else if (nextPagePart != currentPagePart) {
      router.replace(`/cbt/${group}/reading/${page+1}/flow`);
    }
    else {
      router.replace(`/cbt/${group}/reading/${page}`);
      updatePage(page);
    }
  }
  // 終了
  else {
    await exitExam();
  }
}

const exitExam = async () => {
  router.replace(`/cbt/${group}/confirm/end`);
}

// 次のページへ
const nextPage = async () => {
  if (!exam) return;
  const session = await exam.session();
  if (timeRemaining.value === null) return;
  session.readingTimeRemaining = timeRemaining.value;
  await exam.updateSession(session);
  await changePage(currentPage.value+1);
}

// 前のページへ
const prevPage = async () => {
  if (!exam) return;
  const session = await exam.session();
  if (timeRemaining.value === null) return;
  session.readingTimeRemaining = timeRemaining.value;
  await exam.updateSession(session);
  await changePage(currentPage.value-1);
}

// 問題選択
const selectAnswer = async(val: number) => {
  await exam?.answerReading(currentPage.value, val);
  selected.value = val
}

// ページ読み込み時
onMounted(async() => {
  currentPage.value = parseInt(typeof route.params.page === 'string' ? route.params.page : route.params.page[0]);

  await init();
  await updatePage(currentPage.value);

  mounted.value = true;
  console.log('mounted');
});

const init = async() => {
  if (!exam) return;
  const session = await exam.session();
  timeRemaining.value = session.readingTimeRemaining
  timeInitial.value = session.readingTimeRemaining;
  isReachedLastQuestion.value = await exam.isReachedLastQuestion();
}

const updateTimer = async(_timeRemaining: number) => {
  timeRemaining.value = _timeRemaining;
}
const timeover = async() => {
  if (!exam || !app) return;
  await exam.readingEnd();
  app.stopAudio();
  router.replace(`/cbt/${group}/end`);
}

// アニメーション
const pageBeforeEnter = (el: HTMLElement) => {
  el.style.opacity = '0'
}
const pageEnter = (el: HTMLElement) => {
  gsap.to(el, {duration: 0.5, opacity: 1, delay: 0.2, ease: 'power3.easeOut'});
}

const review = () => {
  router.replace(`/cbt/${group}/confirm/review`);
}

const demoPrev = async () => {
  if (!exam) return;
  const session = await exam.session();
  if (timeRemaining.value === null) return;
  session.readingTimeRemaining = timeRemaining.value;
  await exam.updateSession(session);
  const questions = await exam.questions();
  if (questions.listening.pages[currentPage.value].example) {
    router.replace(`/cbt/${group}/reading/${currentPage.value}/flow`);
  } else {
    updatePage(currentPage.value - 1);
  }
}
const demoNext = nextPage;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      (question.value)
        ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
            _createElementVNode("h1", null, [
              _hoisted_2,
              _createElementVNode("span", _hoisted_3, _toDisplayString(question.value.partNumber), 1),
              _hoisted_4,
              (isReachedLastQuestion.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "review-button",
                    onClick: review
                  }, [
                    _hoisted_5,
                    _createTextVNode("し")
                  ]))
                : _createCommentVNode("", true)
            ]),
            (timeInitial.value)
              ? (_openBlock(), _createBlock(Timer, {
                  key: 0,
                  onTimeover: timeover,
                  onUpdate: updateTimer,
                  initTimeRemaining: timeRemaining.value
                }, null, 8, ["initTimeRemaining"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (currentPartQuestions.value && question.value && !question.value.example)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentPartQuestions.value, (mark) => {
              return (_openBlock(), _createElementBlock("li", {
                key: mark.pageNumber,
                class: _normalizeClass({'current': mark.pageNumber === question.value.pageNumber, 'done': mark.pageNumber < question.value.pageNumber})
              }, null, 2))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createVNode(_Transition, {
        appear: "",
        onBeforeEnter: pageBeforeEnter,
        onEnter: pageEnter
      }, {
        default: _withCtx(() => [
          (question.value)
            ? (_openBlock(), _createElementBlock("main", _hoisted_7, [
                _createElementVNode("h2", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, [
                    (!question.value.example)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(question.value.questions[0].questionNumber), 1))
                      : _createCommentVNode("", true),
                    (question.value.example)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, _hoisted_13))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("span", _hoisted_14, [
                    _createElementVNode("span", {
                      class: "en",
                      innerHTML: part.value.directionEn
                    }, null, 8, _hoisted_15),
                    _createElementVNode("span", {
                      class: "jp",
                      innerHTML: part.value.directionJa
                    }, null, 8, _hoisted_16)
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  (mounted.value && part.value.layout === 4)
                    ? (_openBlock(), _createBlock(Layout4, {
                        question: question.value,
                        key: question.value.pageNumber
                      }, null, 8, ["question"]))
                    : _createCommentVNode("", true),
                  (mounted.value && part.value.layout === 5)
                    ? (_openBlock(), _createBlock(Layout5, {
                        question: question.value,
                        key: question.value.pageNumber
                      }, null, 8, ["question"]))
                    : _createCommentVNode("", true),
                  (mounted.value && part.value.layout === 7)
                    ? (_openBlock(), _createBlock(Layout7, {
                        question: question.value,
                        key: question.value.pageNumber
                      }, null, 8, ["question"]))
                    : _createCommentVNode("", true),
                  (mounted.value && part.value.layout === 9)
                    ? (_openBlock(), _createBlock(Layout9, {
                        question: question.value,
                        key: question.value.pageNumber
                      }, null, 8, ["question"]))
                    : _createCommentVNode("", true),
                  (_openBlock(), _createBlock(Answer, {
                    selected: selected.value,
                    question: question.value,
                    onSelectAnswer: selectAnswer,
                    key: question.value.pageNumber
                  }, null, 8, ["selected", "question"]))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (currentPage.value > 0)
        ? (_openBlock(), _createElementBlock("a", {
            key: 2,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (prevPage())),
            class: _normalizeClass(["m-control__prev", {'is-disabled' : disableButton.value}])
          }, _hoisted_19, 2))
        : _createCommentVNode("", true),
      (currentPage.value <= lastPage.value)
        ? (_openBlock(), _createElementBlock("a", {
            key: 3,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (nextPage())),
            class: _normalizeClass(["m-control__next", {'is-disabled' : disableButton.value}]),
            ref_key: "nextButton",
            ref: nextButton
          }, [
            _hoisted_20,
            (startTutorial.value)
              ? (_openBlock(), _createBlock(Tutorial, {
                  key: 0,
                  el: nextButton.value,
                  onActionListener: _cache[1] || (_cache[1] = ($event: any) => (nextPage())),
                  repeat: 1
                }, null, 8, ["el"]))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true),
      _createVNode(Modal, {
        visible: visibleWarningModal.value,
        onClose: _cache[5] || (_cache[5] = ($event: any) => (visibleWarningModal.value = false))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", null, [
              _createElementVNode("a", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (visibleWarningModal.value = false)),
                class: "m-btn is-center"
              }, _hoisted_24),
              _createElementVNode("a", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (exitExam())),
                class: "m-btn is-center"
              }, _hoisted_26)
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _createVNode(DemoControl, {
      onPrev: demoPrev,
      onNext: _unref(demoNext)
    }, null, 8, ["onNext"])
  ], 64))
}
}

})